import storeRoot from '../store-root'
import http from '../../services/http'

const moduleName = 'index'

storeRoot.registerModule(moduleName, {
  namespaced: true,
  state: {
    equipmentList: [],
    equipmentId: null,
    haveVideoBaseId: null,
    isShowMonitor: 0,
    videoMonitor: []
  },
  actions: {

    // 获取带有视频监控的鱼基地键值对信息
    async getHaveVideoBase () {
      let result = await http.get('/api/VideoMonitoring/KeyValue')
      return result.data
    },
    // 获取视频列表
    async getVideoMonitoring ({ commit }, payload) {
      let result = await http.get(`api/VideoMonitoring/2?FishbaseId=${payload}`)

      commit('setVideoMonitor', result.data)
      return (result.data)
    },
    // 获取设备列表
    async getEquipmentList ({ commit }, payload) {
      let result = await http.get('/api/Equipment/2')
      commit('setEquipment', result.data)
    },
    // 增加设备
    async addEquipment ({ commit }, payload) {
      let result = await http.post(`/api/Equipment`, payload)
      return result.data
    },
    // 删除设备
    async deleteEquipment ({ commit }, payload) {
      let result = await http.delete(`/api/Equipment/${payload}`)
      return result
    },
    // 获取设备视图
    async getEditView ({ commit }, payload) {
      let result = await http.get(`/api/Equipment/GetEditView/${payload}`)
      return (result.data)
    },
    // 编辑设备
    async editEquipment ({ commit }, payload) {
      let result = await http.put(`/api/Equipment/${payload.id}`, payload.equipmentValue)
      return (result.data)
    },
    // 校准溶解氧
    async calibrationDissolvedOxygen ({ commit }, payload) {
      let result = await http.put(`/api/EquipmentSocket/CalibrationDissolvedOxygen?id=${payload}`)
      return (result.data)
    }

  },
  mutations: {
    setVideoMonitor (state, payload) {
      state.videoMonitor = payload
    },
    setEquipment (state, payload) {
      state.equipmentList = payload
    },
    setSelectedEquipmentId (state, payload) {
      state.equipmentId = payload
    },
    setHaveVideoBaseId (state, payload) {
      state.haveVideoBaseId = payload
    },
    // 更新设备列表
    updateEquipmentList (state, payload) {
      if (typeof payload === 'number') {
        // 删除
        state.equipmentList.splice(payload, 1)
      } else if (!payload.equipmentValue.rowId) {
        // 增加
        state.equipmentList.push(payload.equipmentValue)
      } else {
        // 更新
        state.equipmentList.splice(payload.index, 1, payload.equipmentValue)
      }
    },
    setMonitor (state, payload) {
      state.isShowMonitor = payload
    }
  }

})

export default moduleName
